import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { GlobalStyles, getPalette, getShadows, themeOptions } from '@/core/theme';
import { ReceiptSubmissionSnackbar, SimpleSnackbar } from '@/shared/components';
import { ConfirmationDialog } from '@/shared/components/ConfirmDialog/components';
import { StyledEngineProvider, ThemeProvider, createTheme } from '@mui/material/styles';
import { Suspense, forwardRef, useMemo } from 'react';
import { maxSnackbars, snackbarAutoHideDuration } from './constants';
import { useLayoutStore } from '@/shared/modules/layout/business';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ruRU } from '@mui/x-date-pickers/locales';
import { ru } from 'date-fns/locale/ru';
import { setDefaultOptions } from 'date-fns/setDefaultOptions';
import { SnackbarProvider } from 'notistack';
import { RouterProvider } from 'react-router-dom';
import { SocketConnectionSnackbar } from './components';
import { useSignalrConnections } from './hooks';
import { router } from './navigation';
setDefaultOptions({ locale: ru });
const russianLocale = ruRU.components.MuiLocalizationProvider.defaultProps.localeText;
export const App = () => {
    const paletteMode = useLayoutStore((state) => state.paletteMode);
    useSignalrConnections();
    const theme = useMemo(() => {
        const currentPalette = getPalette(paletteMode);
        const shadows = getShadows(currentPalette);
        return createTheme({
            ...themeOptions,
            palette: currentPalette,
            shadows: shadows,
            // colorSchemes: { light: true, dark: true },
            cssVariables: {
                cssVarPrefix: 'gp',
            },
        });
    }, [paletteMode]);
    return (_jsx(_Fragment, { children: _jsx(LocalizationProvider, { dateAdapter: AdapterDateFns, adapterLocale: ru, localeText: russianLocale, children: _jsx(StyledEngineProvider, { injectFirst: true, children: _jsxs(ThemeProvider, { noSsr: true, theme: theme, children: [_jsx(CssBaseline, {}), _jsx(GlobalStyles, { theme: theme }), _jsx(SnackbarProvider, { anchorOrigin: { horizontal: 'right', vertical: 'bottom' }, maxSnack: maxSnackbars, 
                            // TODO: `autoHideDuration` is not working for some reason.
                            autoHideDuration: snackbarAutoHideDuration, Components: {
                                default: SimpleSnackbar,
                                success: SimpleSnackbar,
                                info: SimpleSnackbar,
                                warning: SimpleSnackbar,
                                error: SimpleSnackbar,
                                reconnect: forwardRef((props, ref) => _jsx(SimpleSnackbar, { ref: ref, disableClose: true, ...props })),
                                receiptSubmissionSuccess: ReceiptSubmissionSnackbar,
                                receiptSubmissionError: ReceiptSubmissionSnackbar,
                                receiptBlockSuccess: ReceiptSubmissionSnackbar,
                            } }), _jsx(SocketConnectionSnackbar, {}), _jsx(Suspense, { fallback: _jsx(_Fragment, { children: "Loading..." }), children: _jsx(RouterProvider, { router: router }) }), _jsx(ConfirmationDialog, {})] }) }) }) }));
};
